export default "__VITE_ASSET__bQZ0UH4p__"